import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnAgGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { showDialog } from "@widgets/CommonDialog";
import SnResizeBar from "@shared/components/SnResizeBar";
interface Props {
  Menuprops: menuInfo;
}

const EXC000000000029007 = forwardRef(({ Menuprops }: Props, ref) => {
  //region variable
  const gridApiRefH = useRef<any>(null);
  const gridApiRefL = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const { userInfo } = global();
  //#endregion

  //region Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns1, setColums1] = useState<any[]>([]);
  const [columns2, setColums2] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any[]>([]);
  const [dataSource2, setDataSource2] = useState<any>();
  //endregion

  //#region grid 길이 관련
  const cd_menu = Menuprops.cd_menu || "SN_MAS_ORG_REG_005";
  const defaultSize = { panel1: "49.5%", panel2: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({
          menuInfo: Menuprops,
          etcInfo: {},
        });
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums1(rtn.grid.grid1);
        setColums2(rtn.grid.grid2);
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region Button Events
  useImperativeHandle(ref, () => ({
    onSearch,
  }));
  //#endregion

  //#region onSearch
  const onSearch = async () => {
    try {
      const p = {
        ...searchRef.current.getFormdata(),
        g_cd_firm: userInfo.cd_firm,
        g_cd_cust: userInfo.cd_cust || "",
      };
      const params = {
        id: "exc000000000029007_01",
        params: p,
      };

      setDataSource1([]);
      setDataSource2([]);

      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      setDataSource2(data[1] || []);

      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onFocusedRowChanged
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const cd_cust = selectedRow.cd_cust;
      gridApiRefL.current.applyFilters({ cd_cust: cd_cust });
      gridApiRefL.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  //#endregion

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="49.5%">
          <SnAgGrid
            ref={gridApiRefH}
            columnConfig={columns1}
            rowData={dataSource1}
            etcProps={{ title: "거래처" }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="49.5%">
          <SnAgGrid
            ref={gridApiRefL}
            columnConfig={columns2}
            rowData={dataSource2}
            etcProps={{ title: "세부내역" }}
          />
        </SnResizeBar>
      </div>
    </div>
  );
  //#endregion
});

export default EXC000000000029007;
